import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { formatoDecimal } from '../../utilities/formatoNumeros'
import { getLogoPlataformaById, getLabelEstadoById, idEstadosOrden, normalizeIdEstadoOrden } from "../../helper/ordenHelper";

export default class OrdenListItem extends Component {
    copyAlPortapapeles = async (e, valor, etiqueta) => {
        e.stopPropagation();
        if (valor === undefined || valor === null || valor === '') return;
        try {
            await navigator.clipboard.writeText(String(valor));
            toast.success(`${etiqueta} copiado`);
        } catch {
            toast.error('No se pudo copiar al portapapeles');
        }
    };

    render = () => {
        const {
            idOrden,
            idReferencia,
            seller,
            fecha,
            cliente,
            estado,
            tipoEntrega,
            montoVenta,
            productos,
            mailCliente,
            dniIdBocaSeller,
            plataformaCodigo,
            showComision,
            importeComision,
            anulacionMegatone
        } = this.props;
        const changeTipoEntrega = (tipoEntrega) => {
            if (!tipoEntrega) return;
            return (tipoEntrega.includes("sucursal correo")) ? "Env\u00CDo a domicilio" : tipoEntrega;
        }

        const ordenAnulada =
            anulacionMegatone?.anulado === true ||
            (Array.isArray(estado) && estado.some((e) => normalizeIdEstadoOrden(e.idEstado) === idEstadosOrden.anulado));
        const idEstadoBadge = ordenAnulada ? idEstadosOrden.anulado : normalizeIdEstadoOrden(estado?.[0]?.idEstado) ?? estado?.[0]?.idEstado;

        const cardEstadoClass =
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.anulado ? 'orden-card-estado-anulada' :
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.facturado ? 'orden-card-estado-facturada' :
            normalizeIdEstadoOrden(idEstadoBadge) === idEstadosOrden.pendiente ? 'orden-card-estado-pendiente' : '';

        return (
            <div
                className={`w-100 list-group-item hover-background-color orden-card-por-estado ${cardEstadoClass}`.trim()}
                style={{ margin: 0 }}
            >
                <div className="row align-items-center text-center text-break">
                    <div className="col-12 col-md-2">
                        <h6 className="font-weight-bold">{seller}</h6>
                        <span className="d-block font-size-072rem">{fecha?.slice(0, 10)}</span>
                        <span
                            className="d-block font-size-072rem orden-copy-id"
                            title="Clic para copiar N° orden"
                            role="button"
                            tabIndex={0}
                            onClick={(e) => this.copyAlPortapapeles(e, idOrden, 'N° orden')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, idOrden, 'N° orden'); } }}
                        >{idOrden}</span>
                        {idReferencia && (
                            <>
                                <span className="d-block font-size-072rem">Id Referencia</span>
                                <span
                                    className="d-block font-size-072rem orden-copy-id"
                                    title="Clic para copiar id referencia"
                                    role="button"
                                    tabIndex={0}
                                    onClick={(e) => this.copyAlPortapapeles(e, idReferencia, 'Id referencia')}
                                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, idReferencia, 'Id referencia'); } }}
                                >{idReferencia}</span>
                            </>
                        )}
                    </div>
                    <div className="col-12 col-md-2">
                        <small className="font-14 font-weight-bold applyFont d-block my-1">{cliente}</small>
                        <small hidden={!mailCliente || mailCliente.length < 1} className="applyFont d-block my-1">{mailCliente}</small>
                        <img src={getLogoPlataformaById(plataformaCodigo)} alt="" style={{ width: "50px" }} className="my-1" />
                        <small className="d-block fw-bold mt-1">{dniIdBocaSeller != 0 ? dniIdBocaSeller : ""}</small>
                    </div>
                    <div className="col-12 col-md-5">
                        {Array.isArray(productos) && productos.map((producto, i, { length }) => (
                            <div className="row align-items-center justify-content-center" key={i}>
                                <div className="col-12 col-md-3">
                                    <img alt="user-img" className="mw-60px img-responsive" src={producto.imagenPrincipal ?? "https://www.megatone.net/Images/Marketplaces/EnProceso_zoom2x.png"} />
                                </div>
                                <div className="col-md-9">
                                    <h6 className="box-title m-b-5 font-weight-bold">
                                        <small className="applyFont">{producto.cantidad}x </small>{producto.titulo}
                                    </h6>
                                    <small className="applyFont d-block">Precio unitario: ${formatoDecimal(producto.precioUnitario)}</small>
                                    <small className="applyFont d-block">SKU Seller: {producto.sellerSku}</small>
                                    <small className="applyFont d-block">SKU Market: {producto.skuMarket}</small>
                                </div>
                                <div className="col-9 col-md-10 border-bottom" hidden={i + 1 === length} />
                            </div>
                        ))}
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="row">
                            <div className="col-12 col-xxl-7">
                                <h5 className="font-weight-bold box-title d-block">${formatoDecimal(montoVenta)}</h5>
                                <br />
                                {showComision && <h5 className="box-title d-block">${formatoDecimal(importeComision)}</h5>}
                            </div>
                            <div className="col-12 col-xxl-5 orden-estado-label-wrap px-1">
                                <span className={`label label-${getLabelEstadoById(idEstadoBadge).color} orden-estado-label`}>
                                    {getLabelEstadoById(idEstadoBadge).label}
                                </span>
                                <small className="d-block my-1">{changeTipoEntrega(tipoEntrega)}</small>
                                {ordenAnulada && anulacionMegatone?.motivoAnulacion ? (
                                    <small className="d-block my-1">{anulacionMegatone.motivoAnulacion}</small>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
